<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>Cadastrar Novo Pagamento</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3">
            <label>Para quem</label>
            <select class="form-select" v-model="state.tipo.value" @change="changeFetch($event.target.value)">
              <option value="CLINICA">Clinica
              </option>
              <option value="PROFISSIONAL">Profissional
              </option>
            </select>
            <span v-if="state.tipo.error" class="text-danger">Este campo é obrigatório</span>
          </div>
          <div class="col-md-3" v-if="state.tipo.value != 'PROFISSIONAL'">
            <label>Clínica</label>
            <select class="form-select" v-model="state.clinica_id.value">
              <option v-for="clinica in state.clinicas" :key="clinica.id" :value="clinica.id">
                {{ clinica.nome }}
              </option>
            </select>
            <span v-if="state.clinica_id.error" class="text-danger">Este campo é obrigatório</span>
          </div>
          <div class="col-md-3" v-else>
            <label>Profissional</label>
            <select class="form-select" v-model="state.profissional_id.value">
              <option v-for="profissional in state.profissionais" :key="profissional.id" :value="profissional.id">
                {{ profissional.nome }}
              </option>
            </select>
            <span v-if="state.profissional_id.error" class="text-danger">Este campo é obrigatório</span>
          </div>
          <div class="col-md-3">
            <label>Tipo Pagamento</label>
            <select class="form-select" v-model="state.tipo_pagamento.value">
              <option value="CARTAO">Cartão
              </option>
              <option value="BOLETO">Boleto
              </option>
              <option value="PIX">Pix
              </option>
            </select>
            <span v-if="state.tipo_pagamento.error" class="text-danger">Este campo é obrigatório</span>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarCat" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/pagamento-clinicas">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      tipo: {
        value: "CLINICA",
        error: false,
      },
      clinica_id: {
        value: "",
        error: false,
      },
      profissional_id: {
        value: "",
        error: false,
      },
      tipo_pagamento: {
        value: "",
        error: false,
      },
      erro_imagem: false,
      clinicas: [],
      profissionais: [],
    });
    onMounted(() => {
      if (state.tipo.value != 'PROFISSIONAL') {
        fetchClinicas()
      }
    });
    async function fetchClinicas() {
      try {
        const { data } = await services.clinica.getAll({ token });
        console.log(data);
        state.clinicas = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchProfissionais() {
      try {
        const { data } = await services.profissionais.getAll({ token });
        state.profissionais = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarCat() {
      var erro_validacao = false;

      if (state.nome.value.length == 0) {
        state.nome.error = true;
        erro_validacao = true;
      }
      if (state.imagem.imagem == null || state.imagem.imagem == undefined) {
        state.erro_imagem = true;
        erro_validacao = true;
      }
      if (erro_validacao == true) {
        return;
      }

      let dados = new FormData();
      dados.append("nome", state.nome.value);
      if (state.imagem.file != null) {
        dados.append("imagem", state.imagem.file);
      }
      if (!state.id) {
        await services.categoria_loja
          .save({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "CategoriasLoja" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        dados.append("id", state.id);
        dados.append("_method", "PATCH");
        if (state.imagem.imagem == undefined) {
          try {
            await services.categoria_loja.deletarImagem({
              id: dados.get("id"),
            });
          } catch (error) {
            console.log(error);
          }
        }
        await services.categoria_loja
          .update({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "CategoriasLoja" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    async function changeFetch(tipo) {
      try {
        if (tipo !== 'CLINICA') {
          fetchProfissionais()
        } else {
          fetchClinicas()
        }
      } catch (error) {
        console.log('Erro:' + error)
      }

    }
    return {
      salvarCat,
      router,
      state,
      changeFetch,
      fetchProfissionais,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #47b0a9;
}

select {
  border: solid 1px #000;
}

select:focus {
  border: solid 1px #47b0a9;
}

.btns_right {
  text-align: right;
  margin-top: 1rem;
}

.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_save:hover {
  background: #008000;
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_cancel:hover {
  background: #8f0303;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

textarea {
  resize: none;
  border: solid 1px #000;
}

textarea:focus {
  border: solid 1px #47b0a9;
}

#pills-home-tab {
  color: #000;
}

#pills-home-tab:focus {
  color: #47b0a9;
}

#pills-profile-tab {
  color: #000000;
}

#pills-profile-tab:focus {
  color: #47b0a9;
}

.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}

tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}

thead {
  color: #000;
  text-align: center;
  background: gray;
}

td {
  color: #000;
  text-align: center;
}

.table {
  margin-top: 2rem;
}

.imagem {
  width: 100%;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
}

.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
</style>